(function(){
"use strict";
/* ===== Radio DEMA =====
   musica: il tappeto, gira sotto
   voci: messaggi parlati, entrano SOPRA la musica che si abbassa
   canzoni: brani cantati, girano DA SOLI

   VOLUME SU IPHONE: iOS ignora il comando che regola il volume di un
   audio, quindi la musica restava alta e copriva la voce. Si passa
   allora dal motore audio del browser, che il volume lo governa
   davvero. Se non fosse disponibile, la musica viene messa in pausa
   mentre si parla: meglio il silenzio che una voce coperta. */

var dati;
try{ dati = JSON.parse(document.getElementById("drPalinsesto").textContent); }catch(e){ return; }
if(!dati || !dati.musica || !dati.musica.length) return;

var barra = document.getElementById("dradio");
var tasto = document.getElementById("drTasto");
var stato = document.getElementById("drStato");
if(!barra || !tasto) return;

var CHIAVE = "dema_radio";
var VOL_MUSICA = 0.34;
var VOL_DUCK   = 0.07;
var ATTESA_MIN = 3500;
var ATTESA_MAX = 7000;
var PRIMO      = 2500;
var OGNI_CANZONE = 3;

barra.hidden = false;

var musica = new Audio();
musica.preload = "none";
musica.crossOrigin = "anonymous";
musica.volume = VOL_MUSICA;

var parlato = new Audio();
parlato.preload = "none";
parlato.crossOrigin = "anonymous";
parlato.volume = 1;

/* ---- controllo del volume che funziona anche su iPhone ---- */
var ctx = null, guadagno = null, conManopola = false, pausaInvece = false;

function preparaVolume(){
 if(ctx || pausaInvece) return;
 try{
  var AC = window.AudioContext || window.webkitAudioContext;
  if(!AC) throw 0;
  ctx = new AC();
  var sorgente = ctx.createMediaElementSource(musica);
  guadagno = ctx.createGain();
  guadagno.gain.value = VOL_MUSICA;
  sorgente.connect(guadagno);
  guadagno.connect(ctx.destination);
  conManopola = true;
 }catch(e){
  /* niente motore audio: si ripiega sulla pausa */
  ctx = null; guadagno = null; conManopola = false; pausaInvece = true;
 }
}

function abbassa(){
 if(conManopola && ctx){
  try{ ctx.resume(); }catch(e){}
  var t = ctx.currentTime;
  guadagno.gain.cancelScheduledValues(t);
  guadagno.gain.setValueAtTime(guadagno.gain.value, t);
  guadagno.gain.linearRampToValueAtTime(VOL_DUCK, t + 0.45);
 }else if(pausaInvece){
  musica.pause();
 }else{
  musica.volume = VOL_DUCK;
 }
}
function rialza(){
 if(conManopola && ctx){
  var t = ctx.currentTime;
  guadagno.gain.cancelScheduledValues(t);
  guadagno.gain.setValueAtTime(guadagno.gain.value, t);
  guadagno.gain.linearRampToValueAtTime(VOL_MUSICA, t + 0.8);
 }else if(pausaInvece){
  if(acceso && !eraCanzone) musica.play().catch(function(){});
 }else{
  musica.volume = VOL_MUSICA;
 }
}

var acceso = false;
var vuoleSuonare = false;
var iMusica = 0;
var timerVoce = null;
var ordineVoci = [];
var voceInCorso = null;
var voceDa = 0;
var eraCanzone = false;
var contaVoci = 0;
var iCanzone = 0;
var siglaFatta = false;

try{ siglaFatta = sessionStorage.getItem("dema_radio_sigla")==='1'; }catch(e){}

function mescola(a){
 var b = a.slice();
 for(var i=b.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=b[i]; b[i]=b[j]; b[j]=t; }
 return b;
}
function prossimaVoce(){
 if(!ordineVoci.length) ordineVoci = mescola(dati.voci||[]);
 return ordineVoci.shift();
}
function unoACaso(a){ return a && a.length ? a[Math.floor(Math.random()*a.length)] : null; }

function salva(){
 if(!vuoleSuonare) return;
 try{
  sessionStorage.setItem(CHIAVE, JSON.stringify({
   acceso:true, i:iMusica, t:musica.currentTime||0,
   voce:voceInCorso, voceT:voceInCorso?(parlato.currentTime||voceDa||0):0,
   canzone:eraCanzone, coda:ordineVoci, conta:contaVoci, ic:iCanzone,
   quando:Date.now()
  }));
 }catch(e){}
}
function dimentica(){ try{ sessionStorage.removeItem(CHIAVE); }catch(e){} }
function leggi(){
 try{ return JSON.parse(sessionStorage.getItem(CHIAVE)||"null"); }catch(e){ return null; }
}
setInterval(salva, 1000);
addEventListener("pagehide", salva);
addEventListener("beforeunload", salva);
document.addEventListener("visibilitychange", function(){ if(document.hidden) salva(); });

function caricaMusica(indice, secondo){
 iMusica = indice % dati.musica.length;
 musica.src = dati.musica[iMusica];
 if(secondo){
  musica.addEventListener("loadedmetadata", function once(){
   musica.removeEventListener("loadedmetadata", once);
   try{ musica.currentTime = secondo; }catch(e){}
  });
 }
}
musica.addEventListener("ended", function(){
 caricaMusica(iMusica + 1, 0);
 if(acceso && !eraCanzone) musica.play().catch(function(){});
});

function prossimoTurno(){
 if(!acceso) return;
 var canzoni = dati.canzoni || [];
 if(canzoni.length && contaVoci >= OGNI_CANZONE){
  contaVoci = 0;
  var brano = canzoni[iCanzone % canzoni.length];
  iCanzone++;
  mandaCanzone(brano, 0, true);
 }else{
  mandaVoce();
 }
}

function mandaVoce(){
 if(!acceso) return;
 var voce = prossimaVoce();
 if(!voce){ programma(); return; }
 contaVoci++;
 abbassa();
 var st = unoACaso(dati.stacchi);
 if(st){
  parlato.src = st;
  parlato.onended = function(){ diciLa(voce, 0); };
  parlato.play().catch(function(){ diciLa(voce, 0); });
 }else{
  diciLa(voce, 0);
 }
}
function diciLa(voce, daSecondo){
 if(!acceso) return;
 eraCanzone = false;
 voceInCorso = voce;
 voceDa = daSecondo || 0;
 parlato.src = voce;
 if(daSecondo) posiziona(parlato, daSecondo);
 abbassa();
 parlato.onended = function(){
  parlato.onended = null;
  voceInCorso = null; voceDa = 0;
  rialza();
  if(stato) stato.textContent = "Ascolta mentre scegli";
  salva(); programma();
 };
 parlato.play().catch(function(){
  voceInCorso = null; voceDa = 0;
  rialza(); programma();
 });
 if(stato) stato.textContent = "In onda";
 salva();
}

function mandaCanzone(brano, daSecondo, conStacco){
 if(!acceso) return;
 eraCanzone = true;
 voceInCorso = brano;
 voceDa = daSecondo || 0;
 function parti(){
  musica.pause();
  parlato.src = brano;
  if(daSecondo) posiziona(parlato, daSecondo);
  parlato.onended = function(){
   parlato.onended = null;
   voceInCorso = null; voceDa = 0; eraCanzone = false;
   rialza();
   musica.play().catch(function(){});
   if(stato) stato.textContent = "Ascolta mentre scegli";
   salva(); programma();
  };
  parlato.play().catch(function(){
   voceInCorso = null; eraCanzone = false;
   musica.play().catch(function(){});
   programma();
  });
  if(stato) stato.textContent = "In onda";
  salva();
 }
 var st = conStacco ? unoACaso(dati.stacchi) : null;
 if(st && !daSecondo){
  abbassa();
  parlato.src = st;
  parlato.onended = parti;
  parlato.play().catch(parti);
 }else{
  parti();
 }
}

function posiziona(audio, secondo){
 audio.addEventListener("loadedmetadata", function once(){
  audio.removeEventListener("loadedmetadata", once);
  try{ audio.currentTime = secondo; }catch(e){}
 });
}

function programma(){
 clearTimeout(timerVoce);
 var attesa = ATTESA_MIN + Math.random()*(ATTESA_MAX-ATTESA_MIN);
 timerVoce = setTimeout(prossimoTurno, attesa);
}

function apertura(){
 var canzoni = dati.canzoni || [];
 function dopoSigla(){
  clearTimeout(timerVoce);
  if(canzoni.length){
   contaVoci = 0; iCanzone = 1;
   setTimeout(function(){ mandaCanzone(canzoni[0], 0, false); }, 400);
  }else{
   timerVoce = setTimeout(prossimoTurno, PRIMO);
  }
 }
 if(!dati.sigla || siglaFatta){ dopoSigla(); return; }
 siglaFatta = true;
 try{ sessionStorage.setItem("dema_radio_sigla","1"); }catch(e){}
 abbassa();
 parlato.src = dati.sigla;
 parlato.onended = function(){ parlato.onended = null; dopoSigla(); };
 if(stato) stato.textContent = "In onda";
 parlato.play().catch(dopoSigla);
}

function avvia(conApertura, ripresa, secondo, eraUnaCanzone){
 acceso = true;
 vuoleSuonare = true;
 barra.classList.add("on");
 preparaVolume();
 if(!eraUnaCanzone) musica.play().catch(function(){});
 clearTimeout(timerVoce);
 if(ripresa){
  if(eraUnaCanzone) mandaCanzone(ripresa, secondo||0, false);
  else diciLa(ripresa, secondo||0);
 }else if(conApertura){
  apertura();
 }else{
  timerVoce = setTimeout(prossimoTurno, PRIMO);
 }
 salva();
}

function accendi(){
 if(!musica.src) caricaMusica(0, 0);
 avvia(true, null, 0, false);
}
function spegni(){
 acceso = false; vuoleSuonare = false;
 barra.classList.remove("on");
 musica.pause(); parlato.pause();
 clearTimeout(timerVoce);
 if(stato) stato.textContent = "Ascolta mentre scegli";
 dimentica();
}

tasto.addEventListener("click", function(){ acceso ? spegni() : accendi(); });

(function riprendi(){
 var s = leggi();
 if(!s || !s.acceso) return;
 var salto = (Date.now() - (s.quando||0)) / 1000;
 if(salto > 20 || salto < 0) salto = 0;
 if(Array.isArray(s.coda)) ordineVoci = s.coda;
 contaVoci = s.conta || 0;
 iCanzone  = s.ic || 0;
 caricaMusica(s.i||0, (s.t||0) + salto);
 vuoleSuonare = true;
 barra.classList.add("on");
 var ripresa = s.voce || null;
 var eraCanz = !!s.canzone;
 var secondo = ripresa ? (s.voceT||0) + salto : 0;
 function parti(){ avvia(false, ripresa, secondo, eraCanz); }
 var prova = eraCanz ? Promise.resolve() : musica.play();
 prova.then(parti).catch(function(){
  acceso = false;
  var fatto = false;
  function alPrimoGesto(){
   if(fatto) return;
   fatto = true;
   ["pointerdown","touchstart","keydown","scroll"].forEach(function(ev){
    removeEventListener(ev, alPrimoGesto, true);
   });
   parti();
  }
  ["pointerdown","touchstart","keydown","scroll"].forEach(function(ev){
   addEventListener(ev, alPrimoGesto, true);
  });
 });
})();
})();
